require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-04-i-think-im-turning-open-source.json") })
        }
      }, "path---articles-2008-04-i-think-im-turning-open-source");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-04-i-think-im-turning-open-source!./.cache/json/articles-2008-04-i-think-im-turning-open-source.json
// module id = 381
// module chunks = 231608221292675